import React from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__24} from '@homeaway/svg-defs';
import {MENU__24} from '@homeaway/svg-defs';

export default function PureHeader({
    logoNavClass,
    logo,
    navItems,
    search,
    hiddenSearchBtnClass,
    handleClick,
    handleToggle,
    isOpen,
}) {
    const menuVisibility = isOpen
        ? 'Header--mobile-show'
        : 'Header--mobile-hide';
    return (
        <div className="Header bg--color-bg-accent border-border-color">
            <div className={`Header__logo ${logoNavClass}`}>
                <a
                    className="Header__logo-link"
                    href={logo.link}
                    title=""
                    itemProp="url"
                >
                    <img
                        className="Header__logo-img"
                        src={logo.image}
                        alt={logo.altText}
                    />
                </a>
            </div>
            <div className="Header__flex-spacer" />
            {/* hide navigation section if there aren't any nav items  */}
            {navItems && (
                <nav className="Header__nav" role="navigation">
                    {navItems.map((navItem) => (
                        <a
                            key={navItem.label}
                            className="Header__link hidden-xs"
                            href={navItem.url}
                        >
                            {navItem.label}
                        </a>
                    ))}
                </nav>
            )}
            {/* site search button, with hidden-sm class if nav item text is extra long */}
            <a
                href={search.url}
                className={`Header__btn btn btn-default btn-sm hidden-xs ${hiddenSearchBtnClass}`}
            >
                {search.label}
            </a>
            {/* header tray open button, hidden if no navigation */}
            {navItems && (
                <div className="Header__navbar">
                    <button
                        className="Header__tray-toggle visible-xs"
                        onClick={handleClick}
                    >
                        <SVGIcon markup={MENU__24} />
                    </button>
                </div>
            )}
            {/* Header tray, hidden if no navigation */}
            {navItems && (
                <div className={`Header-tray flex-item ${menuVisibility}`}>
                    <div>
                        <div
                            className="Header__backdrop"
                            onMouseDown={handleClick}
                            role="none"
                            tabIndex="-1"
                        />
                    </div>

                    <div className="Header-tray__container bg--color-bg-contrast">
                        <div className="Header-tray__header">
                            <div className="Header-tray__header--close">
                                <button
                                    className="Header__tray-toggle visible-xs"
                                    data-toggle="slidemenu"
                                    onClick={handleToggle}
                                >
                                    <SVGIcon markup={CLOSE__24} />
                                </button>
                            </div>
                        </div>
                        <div className="Header-tray__container__items">
                            <div className="Header-tray__menu">
                                <div className="Header-tray__menu-items">
                                    {navItems.map((navItem) => (
                                        <a
                                            key={navItem.label}
                                            className="Header-tray__menu-item-link"
                                            href={navItem.url}
                                        >
                                            {navItem.label}
                                        </a>
                                    ))}
                                </div>

                                <div className="Header-tray__menu-item-search">
                                    <a
                                        href={search.url}
                                        className="Header__btn btn btn-default btn-sm"
                                    >
                                        {search.label}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

PureHeader.propTypes = {
    logo: PropTypes.shape({
        link: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        altText: PropTypes.string,
    }).isRequired,
    navItems: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    ),
    search: PropTypes.shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }).isRequired,
    handleClick: PropTypes.func,
    handleToggle: PropTypes.func,
    isOpen: PropTypes.bool,
};

PureHeader.defaultProps = {
    logo: {
        image:
            'https://csvcus.homeaway.com/rsrcs/cdn-logos/4.7.0/sitename/vrbo/web/logo.svg',
        link: 'https://www.vrbo.com/',
        altText: 'Vrbo logo',
    },
    search: {
        label: 'Search vacation rentals',
        url: 'https://www.vrbo.com',
    },

    handleClick: () => {
        /* NOOP */
    },
    handleToggle: () => {
        /* NOOP */
    },
    isOpen: false,
};
